import { render } from "./TableUsercomm.vue?vue&type=template&id=456fd412&scoped=true"
import script from "./TableUsercomm.vue?vue&type=script&lang=js"
export * from "./TableUsercomm.vue?vue&type=script&lang=js"

import "./TableUsercomm.vue?vue&type=style&index=0&id=456fd412&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456fd412"]])

export default __exports__